import type { Container } from 'pixi.js';
import { Sprite, Text } from 'pixi.js';
import type { DisplayObjectProps, SpriteProps, TextProps } from './DisplayObjectProps';
import applySpriteProps from './applySpriteProps';
import applyDisplayObjectProps from './applyDisplayObjectProps';
import applyTextProps from './applyTextProps';

type SupportedObjects = Sprite | Container | Text;
export type AllProps = SpriteProps & DisplayObjectProps & TextProps;

export default function props<T extends SupportedObjects>(object: T, objectProps: AllProps): T {
  if (object instanceof Sprite) {
    applySpriteProps(object, objectProps as SpriteProps);
  } else if (object instanceof Text) {
    applyTextProps(object, objectProps as TextProps);
  } else {
    applyDisplayObjectProps(object, objectProps);
  }
  return object;
}
